import React, { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FILTERSET_EDITOR_TYPE_ALLOCATION_RULE } from '../constants/filterset-editor-type';
import { noop } from 'ui-components/default-props/noop';
import FilterEditorModal from '../modal';

const AllocationRuleEditorLink = ({ filterId, allocationRuleName, theme, className, onRuleNameUpdated, onRuleEditorClosed = noop }) => {
  const [isModalOpen, setIsModalOpen] = useAsyncSafeState(false);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    if (onRuleEditorClosed) {
      onRuleEditorClosed();
    }
  }, [onRuleEditorClosed, setIsModalOpen]);

  return (
    <>
      <Button className={className} onClick={openModal} theme={theme}>
        {allocationRuleName}
      </Button>
      {isModalOpen && (
        <FilterEditorModal
          filterId={filterId}
          filterName={allocationRuleName}
          filtersetEditorType={FILTERSET_EDITOR_TYPE_ALLOCATION_RULE}
          onClose={closeModal}
          onRuleNameUpdated={onRuleNameUpdated}
        />
      )}
    </>
  );
};

AllocationRuleEditorLink.propTypes = {
  filterId: PropTypes.number.isRequired,
  allocationRuleName: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string,
  onRuleNameUpdated: PropTypes.func.isRequired,
  onRuleEditorClosed: PropTypes.func,
};

export default AllocationRuleEditorLink;
